export function makeStepThreeOptions () {
  return {
    headers: [
      {
        text: 'SSL Features',
        value: 'features',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Premium AlphaSSL',
        value: 'alphassl',
        sortable: false,
        align: 'center',
        chip: {
          text: 'RECOMMENDED',
          color: 'red',
        }
      },
      {
        text: 'Let’s Encrypt SSL',
        value: 'le',
        sortable: false,
        align: 'center',
        chip: {
          text: 'ALREADY INSTALLED',
          color: 'gray',
        }
      },
    ],
    items: [
      {
        feature: {
          text: 'Price'
        },
        alphassl: {
          text: `
                    <b class="red--text">
                        SPECIAL PRICE
                    </b> <br>
                    <b>$49.95</b> <br>
                    <small><del>(Regular: $99.95 per year)</del></small>`
        },
        le: {
          text: 'Free'
        },
      },
      {
        feature: {
          text: 'Recommended Use'
        },
        alphassl: {
          text: 'Business & E-Commerce'
        },
        le: {
          text: 'Personal Website',
        },
      },
      {
        feature: {
          text: 'Renewal Period'
        },
        alphassl: {
          text: 'Annually, automated'
        },
        le: {
          text: 'Quarterly, automated',
          hint: 'While Let’s Encrypt SSL certificates are issued for 90 days, it is recommended that renewal ' +
                'take place every 60 days to avoid potential outages on Let’s Encrypt’s network. GreenGeeks ' +
                'provides automated renewal, however, we cannot be responsible for failed issuance.'
        },
      },
      {
        feature: {
          text: 'Multiple Sub-Domains'
        },
        alphassl: {
          text: '',
          icon: {
            withText: false,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: '',
          icon: {
            withText: false,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
      },
      {
        feature: {
          text: '256 Bit Encryption'
        },
        alphassl: {
          text: '',
          icon: {
            withText: false,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: '',
          icon: {
            withText: false,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
      },
      {
        feature: {
          text: 'Mobile Compatibility'
        },
        alphassl: {
          text: '100%',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: '85%',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
          hint: 'Let’s Encrypt is compatible with all current browsers and mobile devices.' +
                ' Some legacy services such as Windows XP will not recognize Let’s Encrypt as a secure service. ' +
                'The percentage is based on averages of browsers and devices used by top 100,000 websites.'
        },
      },
      {
        feature: {
          text: 'Browser Compatibility'
        },
        alphassl: {
          text: '100%',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: '85%',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
          hint: 'Let’s Encrypt is compatible with all current browsers and mobile devices.' +
                ' Some legacy services such as Windows XP will not recognize Let’s Encrypt as a secure service. ' +
                'The percentage is based on averages of browsers and devices used by top 100,000 websites.'
        },
      },
      {
        feature: {
          text: 'SSL Site Seal'
        },
        alphassl: {
          text: 'Included',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: '',
          icon: {
            withText: false,
            name: 'mdi-close-circle',
            color: 'red'
          },
        },
      },
      {
        feature: {
          text: 'SSL Warranty'
        },
        alphassl: {
          text: '$10,000 Value',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: 'No',
          icon: {
            withText: false,
            name: 'mdi-close-circle',
            color: 'red'
          },
        },
      },
      {
        feature: {
          text: 'Installation Help'
        },
        alphassl: {
          text: 'Yes',
          icon: {
            withText: false,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
        },
        le: {
          text: 'Partial',
          icon: {
            withText: true,
            name: 'mdi-checkbox-marked-circle',
            color: 'primary'
          },
          hint: 'For Let’s Encrypt we will aid in configuring an .htaccess redirect and diagnosing any SSL' +
                ' errors. Instructions on resolving these errors will be provided to the customer, but limited' +
                ' assistance with remedying them will be provided.'
        },
      },
    ],
    provider: '',
    providers: [
      {
        value: 0,
        text: 'AlphaSSL',
      },
      {
        value: 1,
        text: 'Let\'s Encrypt',
      },
    ]
  }
}
